import { Icon, Box, Button, keyframes } from '@chakra-ui/react';
import { TfiClose } from 'react-icons/tfi';

const rippleAnimationKeys = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(1.5);
    opacity: 0;
  }
`;

export const RippleBackBtn = (props: { width?: number | string; sx?: object; [key: string]: any }) => {
  const { width, sx } = props;
  const rippleAnimation = `1.5s ease-out ${rippleAnimationKeys} infinite`;

  return (
    <Button
      variant='outline'
      w={width || 74}
      h={width || 74}
      minW={width || 74}
      minH={width || 74}
      borderRadius='50%'
      borderWidth={1}
      color='brand.cyan'
      borderColor='brand.cyan'
      fontSize='4xl'
      background='transparent'
      _hover={{ background: 'transparent' }}
      sx={{ aspectRatio: '1/1', ...sx }}
      {...props}
    >
      <Box
        position='absolute'
        w='105%'
        h='105%'
        borderRadius='50%'
        borderColor='rgb(0, 181, 226, .25)'
        borderWidth='1px'
        borderStyle='solid'
        animation={rippleAnimation}
      />
      <Icon as={TfiClose} position='relative' h='50%' />
    </Button>
  );
};
